import React from 'react';
import { Typography } from 'antd';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

const { Title, Paragraph } = Typography;

const cardStyle = {
    backgroundColor: '#f6f6f6',
    borderRadius: '10px',
    padding: '22px',
    boxShadow: '0 3px 8px rgba(0, 0, 0, .2)',
    marginBottom: '20px',
    width: '100%',
    maxWidth: 'none',
};

const titleStyle = {
    fontFamily: 'Poppins,sans-serif',
    fontWeight: '600',
    color: '#000',
    fontSize: '16px',
    marginBottom: '16px',
};

const textStyle = {
    fontFamily: 'Poppins,sans-serif',
    color: '#000',
    fontSize: '14px',
    lineHeight: '20px',
    fontStyle: 'normal',
    fontWeight: '400',
    marginBottom: '1em',
};

const linkStyle = {
    color: '#1a9cb7',
    textDecoration: 'underline',
    fontWeight: '500',
};

const FeatureAnnouncementCard = () => {
    const { t } = useTranslation();
    return (
        <div style={cardStyle}>
            <Title level={4} style={titleStyle}>
                {t('home.feature_announcement.title')}
            </Title>
            <Paragraph style={textStyle}>
                <Trans
                    i18nKey="home.feature_announcement.intro"
                    components={{ b: <b /> }}
                />
            </Paragraph>
            <Paragraph style={textStyle}>
                <Trans
                    i18nKey="home.feature_announcement.bodyText1"
                    components={{ b: <b /> }}
                />
            </Paragraph>

            <Paragraph style={textStyle}>
                <Trans
                    i18nKey="home.feature_announcement.bodyText2"
                    components={{ b: <b /> }}
                />
            </Paragraph>
            <Paragraph style={textStyle}>
                <Trans
                    i18nKey="home.feature_announcement.bodyText3"
                    components={{ b: <b /> }}
                />
            </Paragraph>

            <Paragraph style={textStyle}>
                {t('home.feature_announcement.cta')}{' '}
                <Link to="/reports" style={linkStyle}>
                    {t('home.feature_announcement.link')}
                </Link>
            </Paragraph>
        </div>
    );
};

export default FeatureAnnouncementCard; 